import { render, staticRenderFns } from "./ReceiptEditAddMedV3.vue?vue&type=template&id=004e8bad&"
import script from "./ReceiptEditAddMedV3.vue?vue&type=script&lang=ts&"
export * from "./ReceiptEditAddMedV3.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptEditAddMedV3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
